module.exports = __webpack_public_path__ + "img/agentsystemtray.17682484.png";